import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { UserShort } from '@root/entities/user-short'
import { WalletListItem as WalletListItem_ } from '@root/entities/wallet/ui'
import { useTranslation } from '@root/shared/localization'
import { CopyButton, Dialog, Truncate } from '@root/shared/ui-kit'

import { openBackOfficeUsersWalletsModalEvent } from './atoms/back-office-users-wallets-modal-event'
import { BackOfficeRefreshUsersWalletButton } from './ui/refresh-users-wallet-button'

import type { OpenBackOfficeUsersWalletsModalPayload } from './atoms/back-office-users-wallets-modal-event'
import type { BackOfficeUser } from '@root/entities/back-office'
import type { DelugeId } from '@root/entities/user-short'
import type { WalletModel } from '@root/entities/wallet'

export const BackOfficeUsersWalletsModal = () => {
  const [open, setOpen] = useState<
    OpenBackOfficeUsersWalletsModalPayload | undefined
  >(undefined)

  useEffect(
    () =>
      openBackOfficeUsersWalletsModalEvent.onCall((_, payload) =>
        setOpen(payload),
      ),
    [],
  )

  return (
    <AnimatePresence>
      {open ? (
        <Modal
          user={open.user}
          open={!!open}
          onClose={() => setOpen(undefined)}
        />
      ) : undefined}
    </AnimatePresence>
  )
}

const Content = styled(Dialog.Content.Functional)`
  width: 450px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const Modal = (props: {
  open: boolean
  onClose: () => void
  user: BackOfficeUser.BackOfficeUser
}) => {
  const { t } = useTranslation()
  const [walletsOfSelectedNetwork] = useAtom(
    props.user.walletsOfSelectedNetworkAtom,
  )
  return (
    <Dialog_
      variant="functional"
      open={props.open}
      onOpenChange={props.onClose}
      describedBy={t('back-office.table.wallets')}
    >
      <Dialog.Header.Functional
        title={[
          t('back-office.table.wallets'),
          ':',
          UserShort.someName(props.user),
        ].join(' ')}
      />
      <Dialog.Content.Functional $variant={0}>
        <Content $variant={1}>
          {walletsOfSelectedNetwork.map((wallet) => (
            <WalletListItem
              delugeId={props.user.delugeId}
              key={wallet.id}
              wallet={wallet}
            />
          ))}
        </Content>
      </Dialog.Content.Functional>
    </Dialog_>
  )
}
const Dialog_ = styled(Dialog)`
  grid-template-rows: auto auto;
`

const WalletListItem = (props: { wallet: WalletModel; delugeId: DelugeId }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <WalletListItem_
      wallet={props.wallet}
      onAssetClick={() => {}}
      onClick={() => setExpanded((x) => !x)}
      expanded={expanded}
      renderFooter={() => (
        <Footer>
          <WalletId>
            <Truncate start={6} end={8}>
              {props.wallet.id}
            </Truncate>
          </WalletId>
          <CopyButton value={props.wallet.id} />
          <BackOfficeRefreshUsersWalletButton
            walletId={props.wallet.id}
            delugeId={props.delugeId}
          />
        </Footer>
      )}
    />
  )
}

const WalletId = styled(Typography)`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
const Footer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`
